<div class="" style="padding-right: 5px;padding-top: 1px;width: 132px;height:35px;">
    <div class="input-group" dropdown #dropdown="bs-dropdown">
        <div class="input-group-prepend" id="addressbookicon">
            <span (click)="showAllAgendas();" matTooltip="tous les agendas" matTooltipPosition="above" class="input-group-text agendaicon fakelink">
                <fa-icon [icon]="['fas','calendar']"></fa-icon>
            </span>
        </div>        
        <input type="text" class="form-control" style="width: 87px;height: 27px;font-size: 10px;" placeholder="Agendas">
    </div>
</div>